// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout_wrapper__IdzEe","main":"layout_main__Foe4Z","with-header":"layout_with-header__zRVrs"};